{
  "jobLabel": "Servicio",
  "close": "Cerrar",
  "cancel": "Cancelar",
  "cancelled": "Cancelada",
  "onHold": "En espera",
  "ok": "OK",
  "allow": "Permitir",
  "confirm": "Confirmar",
  "dismiss": "Descartar",
  "pleaseWait": "Espera un momento...",
  "about": "Acerca de",
  "version": "Versión",
  "callUs": "Llámanos",
  "emailUs": "Escríbenos",
  "privacyPolicy": "Política de privacidad",
  "termsOfService": "Términos del servicio",
  "profile": "Perfil",
  "contact": "Contacto",
  "editProfile": "Editar perfil",
  "menu": "Menú",
  "paymentCards": "Tarjetas de pago",
  "address": "Dirección",
  "pointOfInterest": "Punto de interés",
  "myAddresses": "Mis direcciones",
  "operatorLogo": "Logotipo del operador",
  "search": "Buscar",
  "goodsTypes": {
    "passenger": "Pasajero | Pasajeros",
    "passengers": "1 pasajero | {count} pasajeros",
    "parcel": "Paquete | Paquetes",
    "parcels": "1 paquete | {count} paquetes",
    "pallet": "Tarima | Tarimas",
    "pallets": "1 tarima | {count} tarimas",
    "internationalParcel": "Paquete internacional | Paquetes internacionales",
    "internationalParcels": "1 paquete internacional | {count} paquetes internacionales",
    "overnightParcel": "Paquete exprés | Paquetes exprés",
    "overnightParcels": "1 paquete exprés | {count} paquetes exprés",
    "good": "Artículo | Artículos",
    "goods": "1 artículo | {count} artículos"
  },
  "bags": "1 maleta | {count} maletas",
  "cartons": "1 caja | {count} cajas",
  "newBooking": {
    "title": "Nueva reserva",
    "button": "Nueva reserva"
  },
  "editBooking": "Editar reserva",
  "errorOccured": "Ocurrió un error - inténtalo de nuevo",
  "errorCalculatingRoute": "Error al calcular la ruta",
  "addStop": "Agregar parada",
  "searchAddress": "Buscar dirección",
  "addressTypes": "Tipos de dirección",
  "noBookingDetails": "No hay datos de reserva disponibles",
  "pickupDelay": "{dateString} (~{delay} min)",
  "performingQuote": "Calculando la cotización",
  "n/a": "No disponible",
  "approx": "aprox.",
  "est": "Est.",
  "earliest": "Lo antes posible {dt}",
  "pickup": "Recolección {dt}",
  "arrive": "Llegada {dt}",
  "back": "",
  "areYouSure": "¿Estás seguro?",
  "alertBack": "Atrás",
  "lastRefreshed": "Última actualización: ",
  "storedAddressLabel": "Direcciones",
  "deleteAddress": "Eliminar dirección",
  "noStoredAddressDetails": "No hay direcciones disponibles",
  "alertFilter": "Filtrar",
  "alertYourAddresses": "Tus direcciones",
  "alertAccountAddresses": "Direcciones de la cuenta",
  "alertRecentAddresses": "Direcciones recientes",
  "groupYourAddresses": "Tus direcciones",
  "groupAccountAddresses": "Direcciones de la cuenta",
  "groupRecentAddresses": "Direcciones recientes",
  "buttonAddressBookFrom": "Reservar desde...",
  "buttonAddressBookTo": "Reservar hacia...",
  "buttonAddressEdit": "Editar",
  "mapSearch": "Buscar en el mapa",
  "noAddressesFound": "No se encontraron direcciones",
  "noCountriesFound": "No se encontraron países",
  "save": "Guardar",
  "remove": "Quitar",
  "signOutConfirmation": "¿Quieres cerrar sesión?",
  "exitAppConfirmation": "¿Quieres salir de la aplicación?",
  "minute": "min",
  "hour": "h",
  "booking": "Reserva",
  "noBookingTemplates": "No hay plantillas de reserva disponibles",
  "reporting": {
    "title": "Reportes",
    "selectReport": "Seleccionar reporte",
    "updateReportButton": "Actualizar reporte",
    "noReportsAvailable": "No hay reportes disponibles",
    "noReportSelected": "No se seleccionó ningún reporte",
    "filters": "Filtros del reporte",
    "export": {
      "copy": "Copiar",
      "csv": "CSV",
      "xls": "Excel",
      "pdf": "PDF"
    }
  },
  "actions": "Acciones",
  "noMop": "No hay métodos de pago disponibles",
  "flightSearch": {
    "title": "Búsqueda de vuelos",
    "addFlightDetails": "Agregar datos del vuelo",
    "noFlightsFound": "No se encontraron vuelos",
    "flightWarning": "Advertencia sobre el vuelo",
    "airportArriveWarningMessage": "Revisa el vuelo seleccionado, no creemos que llegue al aeropuerto que elegiste",
    "airportDepartWarningMessage": "Revisa el vuelo seleccionado, no creemos que salga del aeropuerto que elegiste",
    "terminalArriveWarningMessage": "Revisa el vuelo seleccionado, no creemos que llegue a la terminal que elegiste",
    "terminalDepartWarningMessage": "Revisa el vuelo seleccionado, no creemos que salga de la terminal que elegiste",
    "matchFlightTimeHeader": "¿Ajustar a la hora del vuelo?",
    "matchFlightTimeMessage": "¿Quieres ajustar la hora de la reserva a la hora de llegada del vuelo?",
    "selectedAirport": "Aeropuerto seleccionado: {airportCode}",
    "flightAirport": "Aeropuerto del vuelo: {airportCode}",
    "flightTerminal": "Terminal del vuelo: {terminal}",
    "searchButton": "Buscar vuelos"
  },
  "to": "a",
  "from": "de",
  "noContactsFound": "No se encontraron contactos",
  "maintainContact": "Administrar contacto",
  "bookAs": "Reservar como",
  "leadPassenger": "Pasajero principal",
  "bookAsWarning": "Para completar esta reserva, cambiarás a reservar como {contactName}",
  "webAccess": {
    "addJobsMessage": "Lo sentimos, no tienes permisos para crear una reserva, llama al {companyTelephoneNumber}",
    "editJobsMessage": "Lo sentimos, no tienes permisos para editar esta reserva, llama al {companyTelephoneNumber}",
    "cancelJobsMessage": "Lo sentimos, no tienes permisos para cancelar esta reserva, llama al {companyTelephoneNumber}",
    "addCardsMessage": "Lo sentimos, no tienes permisos para agregar tarjetas de pago, llama al {companyTelephoneNumber}",
    "editContactsMessage": "Lo sentimos, no tienes permisos para editar este contacto, llama al {companyTelephoneNumber}",
    "addAddressesMessage": "Lo sentimos, no tienes permisos para agregar direcciones, llama al {companyTelephoneNumber}",
    "editAddressesMessage": "Lo sentimos, no tienes permisos para editar direcciones, llama al {companyTelephoneNumber}",
    "deleteAddressesMessage": "Lo sentimos, no tienes permisos para eliminar direcciones, llama al {companyTelephoneNumber}",
    "canRequestMessage": "Lo sentimos, no tienes permisos para solicitar un vínculo de contacto, llama al {companyTelephoneNumber}"
  },
  "approved": "Aprobado",
  "contactLink": {
    "contactLink": "Vínculo de contacto",
    "linkNewContact": "Vincular nuevo contacto",
    "linkedContacts": "Contactos vinculados",
    "noLinkedContacts": "No hay contactos vinculados",
    "pendingLinkedContacts": "Contactos vinculados pendientes",
    "noPendingLinkedContacts": "No hay contactos vinculados pendientes",
    "authoriseContactLink": "¿Autorizar el vínculo de contacto?",
    "confirmOrRejectContactLink": "¿Quieres confirmar o rechazar este vínculo de contacto?",
    "description": "¿Necesitas hacer reservas en nombre de un colega o administrar su perfil? Solicita acceso ingresando su correo electrónico a continuación; recibirá una notificación de que quieres acceder a su perfil.",
    "pending": "Pendiente",
    "reject": "Rechazar"
  },
  "jobCalendar": {
    "eventTitle": "{companyName}: {firstStop} a {lastStop}",
    "pickup": "Recogida: {address}",
    "via": "Vía: {address}",
    "dropOff": "Destino: {address}",
    "journeyTime": "Tiempo estimado del viaje: {duration}",
    "trackingLink": "Siga su viaje: {url}"
  },
  "jobSharing": {
    "shareRideDetails": "Compartir los datos del viaje",
    "iAm": "Estoy",
    "personIs": "{person} está",
    "shareMessage": "viajando con {companyName} de {firstStop} a {lastStop} el {dt}"
  },
  "noEditAccess": "Sin permiso de edición",
  "noBookingAccess": "Sin acceso a la reserva",
  "invalidBooking": "Datos de reserva no válidos",
  "adminConsole": "Consola de administración",
  "cookieConsent": {
    "message": "Usamos cookies para mejorar tu experiencia y brindar servicios esenciales. Si continúas navegando en nuestro sitio, aceptas el uso de cookies. Para más información, consulta nuestra",
    "privacyPolicy": "Política de privacidad",
    "accept": "Aceptar",
    "dismiss": "Descartar"
  },
  "eta": "Hora estimada de llegada: {eta}",
  "settings": "Configuración",
  "language": "Idioma",
  "appearance": {
    "label": "Apariencia",
    "system": "Sistema",
    "light": "Claro",
    "dark": "Oscuro"
  },
  "bookingButtons": {
    "addFavourite": "Agregar a favoritos",
    "clearFavourite": "Quitar de favoritos",
    "edit": "Editar",
    "share": "Compartir",
    "sendConfirmation": "Enviar confirmación",
    "copy": "Copiar",
    "return": "Regreso",
    "cancel": "Cancelar",
    "addToCalendar": "Agregar al calendario",
    "more": "Más"
  },
  "date": "Fecha",
  "time": "Hora",
  "price": {
    "taxIncluded": "(Incl. {tax} de impuestos)",
    "saving": "Ahorro de {amount}"
  },
  "distance": {
    "outputText": "Distancia {distance}",
    "extraText": "Ten en cuenta que las distancias del viaje son solo estimaciones",
    "metresAway": "a {distance} metros",
    "kilometresAway": "a {distance} km",
    "feetAway": "a {distance} pies",
    "milesAway": "a {distance} millas",
    "miles": "{distance} milla | {distance} millas",
    "kilometres": "{distance} km"
  },
  "journey": {
    "outputText": "Viaje {journey}",
    "extraText": "Ten en cuenta que los tiempos de viaje son solo estimaciones"
  },
  "betweenTwoStrings": "Entre {first} y {second}",
  "quickQuote": "Cotización",
  "bookingConfirmation": {
    "newTitle": "Reserva confirmada",
    "editTitle": "Reserva editada",
    "navigationCountdown": "Se cierra en { secondsRemaining } s",
    "navigateButton": "Ver / administrar la reserva"
  },
  "savedJourneys": {
    "favTitle": "Viajes favoritos",
    "noFavsMessage": "No hay viajes favoritos disponibles",
    "recentTitle": "Viajes recientes",
    "noRecentsMessage": "No hay viajes recientes disponibles",
    "stopsHeader": "Viaje",
    "tariffHeader": "Servicio",
    "goodsHeader": "Mercancía",
    "alert": {
      "addHeader": "¿Agregar este viaje a favoritos?",
      "addMessage": "Agrega una descripción opcional del viaje",
      "editHeader": "Editar descripción",
      "editMessage": "Editar la descripción opcional del viaje",
      "descriptionPlaceholder": "Descripción"
    }
  },
  "location": {
    "permissionMessage": "Para que podamos encontrar tu ubicación actual, permite el acceso"
  },
  "documents": "Documentos",
  "goodsFields": {
    "unitWeight": "Peso",
    "unitHeight": "Altura",
    "unitWidth": "Ancho",
    "unitDepth": "Profundidad",
    "unitValue": "Valor",
    "unitCube": "Volumen",
    "palletType": "Tipo de tarima",
    "palletSubType": "Subtipo de tarima",
    "nonDoc": "Sin documento",
    "volumetricWeight": "Peso volumétrico"
  },
  "viewBooking": {
    "guestInfo": "Información del pasajero",
    "parcelInfo": "Información del paquete",
    "palletInfo": "Información de la tarima",
    "journeyRouteMessage": "El mapa muestra solo una ruta de ejemplo y puede no ser exactamente la que tome el conductor en tu viaje.",
    "jobFlags": "Opciones",
    "jobExtras": "Extras",
    "jobRefs": "Referencias",
    "driverPhoto": "Foto del conductor",
    "vehicleImage": "Imagen del vehículo",
    "tariffImage": "Imagen del servicio",
    "proofOfDelivery": "Comprobante de entrega",
    "webInstructions": "Notas para el conductor",
    "price": "Precio",
    "netPrice": "Precio neto",
    "tax": "Impuestos",
    "totalPrice": "Precio total"
  },
  "dateRelative": {
    "lastWeek": "eeee 'pasado a las' p",
    "yesterday": "'Ayer a las' p",
    "today": "'Hoy a las' p",
    "tomorrow": "'Mañana a las' p",
    "nextWeek": "eeee 'a las' p",
    "other": "P 'a las' p"
  },
  "payment": {
    "cards": "Tarjetas de pago",
    "noCards": "No hay tarjetas de pago disponibles",
    "bookingPaymentTitle": "Pago de la reserva",
    "withCardEnding": "con la tarjeta que termina en {cardNum}",
    "cardValidFrom": "válida desde",
    "cardValidTo": "válida hasta",
    "addCard": "Agregar tarjeta",
    "deleteCard": "Eliminar tarjeta",
    "makeDefaultCard": "Usar como tarjeta predeterminada",
    "pay": "Pagar",
    "savedCards": "Tarjetas guardadas",
    "otherPaymentMethod": "Otro método",
    "adflexNavWarning": "Si ya realizaste un pago, se te cobrará de todas formas"
  },
  "profileContact": {
    "telephone": "Teléfono",
    "mobile": "Celular",
    "account": "Cuenta"
  }
}
